import { cn } from "@/lib/utils";
import type { FileKind } from "@/components/files-browser/FileTileCaption";
import { KIND_COLOR } from "@/components/files-browser/FileTileCaption";

/** 14px stroke glyph per kind — one stroke weight, drawn not emoji. */
export function FileKindGlyph({
  kind,
  className,
}: {
  kind: FileKind;
  className?: string;
}) {
  const common = {
    width: 13,
    height: 13,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  } as const;
  const glyph = (() => {
    switch (kind) {
      case "image":
        return (
          <>
            <rect x="3.5" y="4.5" width="17" height="15" rx="2.5" />
            <circle cx="9" cy="10" r="1.6" fill="currentColor" stroke="none" />
            <path d="M3.5 16.5l5-5 4 4 3-3 4.5 4.5" />
          </>
        );
      case "video":
        return (
          <>
            <rect x="3.5" y="4.5" width="17" height="15" rx="2.5" />
            <path
              d="M10.2 9.2l5 2.8-5 2.8z"
              fill="currentColor"
              stroke="none"
            />
          </>
        );
      case "audio":
        return (
          <>
            <path d="M5 10v4M9 7v10M13 9v6M17 5v14M21 10v4" />
          </>
        );
      case "table":
        return (
          <>
            <rect x="3.5" y="4.5" width="17" height="15" rx="2" />
            <path d="M3.5 10h17M9.5 4.5v15" />
          </>
        );
      case "page":
        return (
          <>
            <circle cx="12" cy="12" r="8.5" />
            <path d="M3.5 12h17M12 3.5c2.6 2.3 2.6 14.7 0 17-2.6-2.3-2.6-14.7 0-17z" />
          </>
        );
      case "code":
        return (
          <>
            <path d="M8 7l-5 5 5 5M16 7l5 5-5 5" />
          </>
        );
      case "report":
      case "doc":
      case "other":
        return (
          <>
            <path d="M6 3.5h8l4 4v13h-12z" />
            <path d="M14 3.5v4h4" />
            <path d="M9 12h6M9 15.5h4" />
          </>
        );
    }
  })();
  return (
    <svg
      {...common}
      aria-hidden
      className={cn("shrink-0", KIND_COLOR[kind], className)}
    >
      {glyph}
    </svg>
  );
}
